import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { iif, Observable, of } from 'rxjs';
import { filter, mergeMap, tap } from 'rxjs/operators';

import { AuthState, AuthStore, BookingStore } from '@store';

@Injectable()
export class MaintainerAuthGuardService implements CanActivate, CanActivateChild {
  constructor(
    private authStore: AuthStore,
    private bookingStore: BookingStore,
    private router: Router
  ) {}

  canActivateChild(): Observable<boolean> {
    return this.checkAuth();
  }

  canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    const hasAccessToBooking$ = this.bookingStore.hasAccessToBooking$.pipe(
      tap((hasAccessToBooking) => {
        if (!hasAccessToBooking) {
          this.router.navigate(['/installations']);
        }
      })
    );

    const hasAccess$ = this.authStore.isMaintainerOrUser$.pipe(
      mergeMap((isMaintainerOrUser) =>
        iif(() => isMaintainerOrUser, hasAccessToBooking$, of(false))
      )
    );

    return this.authStore.state$.pipe(
      filter((state: AuthState) => {
        if (!state.authorized && !state.authorizing && !state.authenticating) {
          this.router.navigate(['/home']);
        }

        return state.authorized;
      }),
      mergeMap((state) => iif(() => state.demo, of(true), hasAccess$))
    );
  }
}
